import React, { useEffect } from "react";

const NewHome = () => {
  useEffect(() => {
    let meta = document.querySelector('meta[name="viewport"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "viewport";
      document.head.appendChild(meta);
    }
    meta.content = "width=device-width, initial-scale=1";
    return () => {};
  }, []);
  return (
    <div style={{ height: "100vh", width: "100vw", overflow: "hidden" }}>
      <iframe
        title="Home"
        src="/external/home/index.html"
        style={{
          height: "100%",
          width: "100%",
          overflow: "hidden",
          border: "none",
        }}
      />
    </div>
  );
};

export default NewHome;
